import axios from 'axios';

import BaseCrud from './baseCrud';

const crud = new BaseCrud('ad-position', 'ad-positions');

export const state = () => ({ ...crud.state });

export const getters = {
    ...crud.getters
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions,

    getAds(
        ctx,
        {
            id,
            currentPage = 1,
            perPage = 10,
            search = '',
            sortBy = 'createdAt',
            descending = true,
            filters = null,
            status = null
        }
    ) {
        const params = {
            status,
            page: currentPage,
            perPage,
            q: search,
            sortBy,
            order: descending ? 'DESC' : 'ASC'
        };

        if (filters) {
            params.filters = JSON.stringify(filters);
        }

        return axios.$get(`/admin/ad-positions/${id}/ads`, {
            params
        });
    }
};
